import { env } from '../../env';
import { logError } from '../logger/logger';

import { isDynatraceEnabled } from './constants';

const FAILED_TO_LOAD_SCRIPT_MESSAGE = '[Dynatrace] Failed to load script';

export const initDynatrace = () => {
	if (!isDynatraceEnabled) return;

	const { CLIENT_DYNATRACE_URL } = env;
	if (!CLIENT_DYNATRACE_URL) return;

	const script = document.createElement('script');
	script.src = CLIENT_DYNATRACE_URL;
	script.crossOrigin = 'anonymous';
	script.type = 'text/javascript';
	script.onload = () => window.dtrum?.enableManualPageDetection?.();
	script.onerror = () => {
		logError(FAILED_TO_LOAD_SCRIPT_MESSAGE, {
			tags: { url: CLIENT_DYNATRACE_URL },
		});
	};
	document.head.appendChild(script);
};
